import { action } from 'typesafe-actions';
import { IApiQueryOptions } from 'api/ApiClient';
import { ICreatePaymentPayload, IHoldbackFixed, IHoldbackPercent, IPayee, IPaymentSet, IUploadPayment } from 'types';
import { Payment } from './types';

export const getPaymentRequest = (paymentId: string, skipCalcsRequest?: boolean) => action(Payment.GET_PAYMENT_REQUEST, { paymentId, skipCalcsRequest });
export const getPaymentSuccess = (response: IPaymentSet) => action(Payment.GET_PAYMENT_SUCCESS, response);
export const getPaymentError = (error: any) => action(Payment.GET_PAYMENT_FAIL, error);

export const uploadPaymentRequest = (siteId: string, payments: IUploadPayment[], onSuccess?: (payments: IUploadPayment[]) => void) => action(Payment.UPLOAD_PAYMENT_REQUEST, { siteId, payments, onSuccess });
export const uploadPaymentSuccess = (response: IUploadPayment[]) => action(Payment.UPLOAD_PAYMENT_SUCCESS, response);
export const uploadPaymentError = (error: any) => action(Payment.UPLOAD_PAYMENT_FAIL, error);

export const getPayeesRequest = (siteId: string, options?: IApiQueryOptions, siteHoldbacks?: IHoldbackFixed | IHoldbackPercent, onSuccess?: (payees: IPayee[]) => void) =>
  action(Payment.GET_PAYEES_REQUEST, { siteId, options, siteHoldbacks, onSuccess });
export const getPayeesSuccess = (response: IPayee[]) => action(Payment.GET_PAYEES_SUCCESS, response);
export const getPayeesError = (error: any) => action(Payment.GET_PAYEES_FAIL, error);

// Pay Payment Set
export const payPaymentSetRequest = (paymentSet: ICreatePaymentPayload) => action(Payment.CREATE_PAYMENT_REQUEST, paymentSet);
export const payPaymentSetSuccess = (response: IPaymentSet) => action(Payment.CREATE_PAYMENT_SUCCESS, response);
export const payPaymentSetError = (error: any) => action(Payment.CREATE_PAYMENT_FAIL, error);
